module.exports = {
	"apertureWidth": "ターゲット ボックスの幅",
	"apertureLength": "ターゲット ボックスの長さ",
	"apertureGap1": "ターゲット ボックスのギャップ 1",
	"apertureGap2": "ターゲット ボックスのギャップ 2",
	"ballDiameter": "ボール直径",
	"bodyOffset": "ボディのオフセット",
	"bodyLength": "ボディの長さ",
	"bodyDiameter": "ボディの直径",
	"bodyHeight": "ボディの高さ",
	"bodyColor": "ボディの色",
	"componentFamily": "コンポーネント ファミリ",
	"colPitch": "列のピッチ",
	"chipArrayNote": "* L1 および b1 はオプションです。",
	"crystalNote": "* (D, D2, L)からオプションの寸法を選択します。組み合わせが異なると、異なるフットプリントのパッド サイズになる可能性があります。",	
	"densityLevel": "密度レベル",	
	"femaleStandoffNote": "* 取り付け穴パッドはオプションで、左図に示す寸法の値を入力して生成できます。穴の直径(b)は、取り付け穴の生成、および内部ねじ切りのないスペーサ機械的モデルに使用します。",
	"footprintOrigin": "フットプリントの原点",
	"hPinPitch": "水平ピンのピッチ",
	"hTerminalGap": "水平端子のギャップ",
	"hTerminalTailLength": "水平端子のテールの長さ",
	"innerThreadDepth": "めねじの深さ",
	"innerThreadSize": "めねじのサイズ",
	"innerThreadDesignation": "めねじの指定",
	"leadDiameter": "リード直径",
	"leadSpan": "リード スパン",
	"leadSpan1": "リード スパン 1",
	"leadSpan2": "リード スパン 2",
	"leadShape": "リード形状",
	"largerTerminalLength": "大きい端子の長さ",
	"largerTerminalWidth": "大きい端子の幅",
	"maleFemaleStandoffNote": "* 取り付け穴パッドはオプションで、左図に示す寸法の値を入力して生成できます。穴の直径(b)は、取り付け穴の生成に使用します。",
	"mapSilkscreen": "シルクスクリーンをボディにマッピング",
	"optionalDimensionNote": "* (D, D2, L)からオプションの寸法を選択します。組み合わせが異なると、異なるフットプリントのパッド サイズになる可能性があります。",
	"oddTerminalLength": "奇数端子の長さ",
	"oddTerminalWidth": "奇数端子の幅",
	"optionalDimension": "オプションの寸法",	
	"partialThread": "部分ねじ",	
	"pasteCoverage": "カバレッジを貼り付け",
	"producibilityLevel": "製造レベル",
	"pinPitch": "ピンのピッチ",
	"padToHoleRatio": "パッドから穴の比率",
	"padRoundness": "パッドの丸み",
	"pinNumbering": "ピンの番号付け",
	"postLength": "おねじの長さ",
	"postThreadSize": "おねじのサイズ",
	"postThreadDesignation": "おねじの指定",
	"rowPitch": "行のピッチ",
	"tabWidth": "タブの幅",
	"tabLength": "タブの長さ",
	"terminalThickness": "端子の厚さ",
	"terminalWidth": "端子の幅",
	"terminalLength": "端子の長さ",
	"terminalGap": "端子のギャップ",
	"terminalCCGap": "端子の中心-中心ギャップ",
	"terminalCCGap1": "端子の中心-中心ギャップ 1",
	"terminalCCGap2": "端子の中心-中心ギャップ 2",
	"terminalTailLength": "端子のテールの長さ",
	"terminalPostLength": "端子の支柱の長さ",
	"terminalType": "端子のタイプ",	
	"threadDepth": "ねじの深さ",
	"threadSize": "ねじのサイズ",
	"threadDesignation": "ねじの指定",	
	"threaded": "ねじ切り",
	"truncateMiddlePin": "中央ピンを切り捨て",		
	"vPinPitch": "垂直ピンのピッチ",
	"vTerminalGap": "垂直端子のギャップ",
	"vTerminalTailLength": "垂直端子のテールの長さ",
	"#Rows": "行数",
	"#Cols": "列数",
	"#Pins": "ピン数",
	"#DPins": "ピン数(D 側)",
	"#EPins": "ピン数(E 側)",
	"padShape": "パッド形状",
	"RESISTOR": "抵抗",
	"NONPOLARIZED_CAPACITOR": "コンデンサ - 無極性",
	"POLARIZED_CAPACITOR": "有極性コンデンサ",
	"DIODE": "ダイオード",
	"FUSE": "ヒューズ",
	"INDUCTOR": "インダクタ",
	"POLARIZED_INDUCTOR": "有極性インダクタ",
	"NONPOLARIZED_INDUCTOR": "インダクタ - 無極性",
	"LRCCW": "左下から反時計回り",
	"LRCW": "左上から時計回り",
	"ZZBT": "左下からジグザグ",
	"PIN_ONE": "ピン 1",
	"CENTER_PADS": "パッドの中心",
	"female": "メス",
	"male": "オス",
	"maleFemale": "オス-メス",
	"ROUND": "丸",
	"HEX": "六角",
	"SQUARE": "角",
	"Round": "丸",
	"Square": "角",
	"RoundedSquare": "丸み付き角",
	"Rectangle": "矩形",
	"Black": "黒",
	"Green": "緑",
	"Blue": "青",
	"Yellow": "黄",
	"Amber": "橙",
	"Brown": "茶",
	"Cyan": "シアン",
	"Maroon": "栗色",
	"Grey": "グレー",
	"Silver": "シルバー",
	"Purple": "紫",
	"Red": "赤",
	"White": "白",
	"Most (A)": "最大(A)",
	"Nominal (B)": "公称(B)",
	"Least (C)": "最小(C)",
	"Most (M)": "最大(M)",
	"Nominal (N)": "公称(N)",
	"Least (L)": "最小(L)",
	"IC": "集積回路(IC)",
	"PRECISION_INDUCTOR": "高精度インダクタ",
	"LED": "LED",
	"THERMISTOR": "サーミスタ",
	"POLARIZED_DIODE": "ダイオード",
	"VARISTOR": "バリスタ",
	"FERRITE_BEAD": "フェライト ビーズ",
	"SOIC_SOP": "SOIC, SOP",
	"QFP": "QFP",
	"CFP": "CFP",
	"CQFP": "CQFP",
	"QFN": "QFN",
	"SOT23": "SOT23",
	"SOTFL": "SOTFL",
	"SOT223": "SOT223",
	"TO_DPAK": "TO, DPAK",
	"SOT143": "SOT143",
	"CHIP": "チップ",
	"SOD": "SOD",
	"MOLDED_BODY": "成形ボディ",
	"SODFL": "SODFL",
	"DFN_2": "DFN-2",
	"DFN_3": "DFN-3",
	"DFN_4": "DFN-4",
	"ECAP": "E-Cap",
	"CRYSTAL": "水晶",
	"BGA": "BGA",
	"MELF": "MELF",
	"CHIP_ARRAY_TWO_SIDE_FLAT_CONCAVE": "チップ アレイ、2 面フラット/凹型",
	"CHIP_ARRAY_FOUR_SIDE_FLAT_CONCAVE": "チップ アレイ、4 面フラット/凹型",
	"CHIP_ARRAY_TWO_SIDE_CONVEX": "チップ アレイ、2 面凸型",
	"PLCC": "PLCC",
	"OSCILLATOR_CORNER_CONCAVE": "オシレータ コーナー凹型",
	"OSCILLATOR_J_LEAD": "オシレータ J リード",
	"OSCILLATOR_L_BEND": "オシレータ L ベンド",
	"SOJ": "SOJ",
	"AXIAL": "軸",
	"DIP": "DIP",
	"PIN_HEADER_STRAIGHT": "ピン ヘッダ(オス)ストレート",
	"PIN_HEADER_RA": "ピン ヘッダ(オス)ライト アングル",
	"RECEPTACLE_HEADER_STRAIGHT": "ソケット ヘッダ(メス)ストレート",
	"RECEPTACLE_HEADER_RA": "ソケット ヘッダ(メス)ライト アングル",
	"SON_DFN": "SON (DFN)",
	"RADIAL_GENERIC": "ラジアル汎用(丸)",
	"RADIAL_LED": "ラジアル LED (丸)",
	"CRYSTAL_HC49": "水晶(HC49)",
	"FEMALE_STANDOFF": "メス スタンドオフ/スペーサ",
	"MALE_FEMALE_STANDOFF": "オス-メス スタンドオフ",
	"SNAP_LOCK": "スナップ ロック",
	"Optional_D": "D (リード スパン)",
	"Optional_D2": "D2 (端子のギャップ)",
	"Optional_L": "L (端子の長さ)",
	"CONCAVE": "凹型",
	"FLAT": "フラット",
	"Oblong": "長丸",
	"Collapsing_Ball": "ボール圧潰",
	"Non_Collapsing_Ball": "ボール非圧潰",
	"mountingHolePad": "取り付け穴パッド",
	"withVias": "ビアあり",
	"viasCount": "ビアの数",
	"viaDiameter": "ビア直径",
	"viaOffset": "穴の中心からのビアのオフセット",
	"viaThermalRelief": "ビアのサーマル リリーフ",
	"radialLedNote": "* c は丸みのあるリード形状には適用できません。",
	"lockHeight": "ロック高さ",
	"overrideLockDiameter": "ロック直径をオーバーライド",
	"lockDiameter": "ロック直径",
	"overridePitch": "ピンのピッチをオーバーライド",
	"bodyWidth": "ボディの幅",
	"padWidth": "パッドの幅",
	"plated": "めっき",
	"ViaOffset": "穴の中心からのビアのオフセット",
	"holeDiameter": "穴直径",
	"snapLockNote1": "* ロック直径(E1)は、ボディの直径(E)と穴の直径(b)に基づいて自動的に計算されます。ただし、ロック直径をオーバーライドしてカスタム値を指定することもできます。",
	"snapLockNote2": "* 穴の直径(b)をボディの直径(E)およびロック直径(E1)と同じにすることはできません",
	"leadWidth": "リードの幅",
	"leadThickness": "リードの厚さ",
	"boardThickness": "ボードの厚さ",
	"error1": "実装されていません。",
	"fabricationTolerance": "製造許容差", 
	"placementTolerance": "配置許容差",
	"CAPACITOR": "コンデンサ - 無極性",
	"CAPACITOR_NONPOLARIZED": "コンデンサ - 無極性",
	"CAPACITOR_NON_POLARIZED": "コンデンサ - 無極性",
	"FILTER": "フィルタ", 
	"TRANSISTOR": "トランジスタ",
	"ecapNote": "* (D, D2, L)からオプションの寸法を選択します。組み合わせが異なると、異なるフットプリントのパッド サイズになる可能性があります。",
	"maximum": "最大", 
	"nominal": "公称", 
	"minimum": "最小",
	"bodyShape": "ボディ形状",
	"customSolderPaste": "カスタムのはんだペースト",
	"thermalPad": "サーマル パッド",
	"thermalPadLength": "サーマル パッドの長さ",
	"thermalPadWidth": "サーマル パッドの幅",
	"RoundedRectangle": "丸み付き長方形",
	"extendedEdgeLength": "拡張エッジ長",
	"Generator": " 発電機",
	"axialNote": "* ピンのピッチは、フットプリントを IPC に準拠させるためにボディのサイズ、端子、および製造レベルに基づいて自動的に計算されます。ただし、ピンのピッチをオーバーライドしてカスタム値を指定し、IPC に準拠しないフットプリントを作成することもできます。",
	"baseHeight": "基準の高さ",
	"CHIP_LED": "チップの LED",
	"updatePreview": "プレビューを更新",
	"Custom": "カスタム",
	"ledColorNote": "* カスタムのボディ色の場合は、16 進法の値を入力します。",
	"customBodyColor": "カスタムのボディ色",							
	"lensShape": "レンズ形状",
	"domeDiameter": "半球体の直径",
	"RECT_FLAT_TOP": "上辺が平坦な長方形",
	"RECT_DOMED_TOP": "上辺が半球状の長方形",
	'customFootprint': 'カスタムのフットプリント',
	'customPadLength': 'カスタムのパッド長さ',
	'customPadWidth': 'カスタムのパッド幅',
	'customPadGap': 'カスタムのパッド間ギャップ',
	'customOddPadWidth': 'カスタムの奇数パッド幅',
	'customOddPadLength': 'カスタムの奇数パッド長さ',
	'customPadDiameter': 'カスタムのパッド直径',
	'customPadSpan1': 'カスタムのパッド スパン 1',
	'customPadSpan2' : 'カスタムのパッド スパン 2',
	'customPadPitch' : 'カスタムのパッド ピッチ',
	'pinPitch1' : 'ピン ピッチ 1',
	'customPadGap1': 'カスタムのパッド間ギャップ 1',
	'Optional_g': 'g (カスタムのパッド ギャップ)',
	'Optional_p': 'p (カスタムのパッド ピッチ)',

	// JS Widgets
	"New_Library": "新規ライブラリ",
	"Components": "コンポーネント",
	"Component": "コンポーネント",
	"Symbols": "記号",
	"Symbol": "記号",
	"Footprints": "フットプリント",
	"Footprint": "フットプリント",
	"Packages": "パッケージ",
	"Package": "パッケージ",
	"No": "いいえ",
	"Name": "名前",
	"Pins": "ピン",
	"Pads": "パッド",
	"Description": "説明",
	"Variants": "バリアント",
	"Type": "タイプ",
	"Hub_URN": "Hub URN",
	"Hub_Version": "Hub Version",
	"Library_io_URN": "Library.io URN",
	"Library_io_Version": "Library.io バージョン",
	"Link": "リンク",
	"Rename": '名前変更',
	"Edit_Description": '説明を編集',
	"Duplicate": '複製', // verb, not noun.  ie "Make a copy"
	"Create_New_3D_Model": '新しい 3D モデルを作成',
	"Attach_Copy_Existing_3D_Model": '既存の 3D モデルのコピーをアタッチ',
	"Edit": '編集',
	"Delete": '削除',
	"Remove_From": '次から削除',
	"Update_To_Latest": '最新に更新',
	"Create_New_Symbol": '新しい記号を作成',
	"Create_New_Footprint": '新しいフットプリントを作成',
	"Create_New_Component": '新しいコンポーネントを作成',
	"Create_New_Package": '新しいパッケージを作成',
	"Delete_Package_Children_Warning": "これにより、このフットプリントで使用されているパッケージも削除されます。",
	"No_Search_Results": "検索結果がありません",
	"No_Library_Loaded": "ライブラリがロードされていません",
	"Library_Stored_Fusion_Hub": "このライブラリは your Fusion Hub に保存されます。",
	"Library_Linked_Managed_Library": "このライブラリは、Library.io 管理ライブラリにリンクされています。",
	"Library_Local_Changes": "このライブラリには、Library.io にプッシュされていない変更があります。これを行うには、[管理]ツールバーに移動してください。",
	"Library_Remote_Changes": "このライブラリには、Library.io から取得できる新しい更新があります。これを行うには、[管理]ツールバーに移動してください。",
	"View_on_Library_io": "Library.io のビュー",
	"Used_In": "使用先",
	"No_Selection": "選択なし",

	"No_Footprints": "フットプリントがありません",
	"No_Symbols": "記号がありません",
	"No_Components": "コンポーネントがありません",
	"No_Packages": "パッケージがありません",

	"Package_Loading_Message": "パッケージが保存およびアップロードされるまでお待ちください。",
	"Attributes": "属性",
	"View_Attributes": "表示の属性",
	"Edit_Attributes": "表示の属性",
	"Edit_Description": "説明を編集",
	
	"Use_Placeholder": "プレースホルダを使用",
	"Placeholder_Message": "3D モデルがフットプリントに関連付けられていない場合は、プレースホルダ形状を使用します。",

	"Hub": "Hub",
	"New_Symbol": '新しいシンボル',
	"New_Footprint": '新しいフットプリント',
	"New_Component": '新規コンポーネント',
	"New_Package": '新しいパッケージ',

	"Asset_Ahead":  "Local changes are detected.  To publish these changes to Library.io, use the 'Manage' toolbar.",
	"Package_Behind_Lio": "Library.io パッケージの更新が可能です。右クリックして[更新]を選択してください。",
	"Package_Behind_Fusion": "Fusion パッケージの更新が可能です。右クリックして[更新]を選択してください。",
	"Package_Behind_Both": "パッケージの更新が可能です。右クリックして[更新]を選択してください。",
	"Package_On_Lio":  "This package exists only on Library.io.  Editing it will create a linked model in your Fusion Hub.",
	"Package_Behind_Blocked": "アセットの変更を取得する前に、ライブラリを更新する必要があります。ライブラリを更新するには、[管理]ツールバーを使用してください。",
}